// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5ec92d84","81":"2f6cdce4","226":"e1bb916d","327":"28de4269","394":"d74dc666","496":"530026d5","606":"7eb88ebf","768":"da6020a3","906":"0ca7e6fd","979":"7124668a","994":"17011b4e"}[chunkId] + ".chunk.js";
};